import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "user-header bg-primary" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "user-footer" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Cerrar sesion ")

export function render(_ctx, _cache) {
  const _component_app_button = _resolveComponent("app-button")
  const _component_app_dropdown = _resolveComponent("app-dropdown")

  return (_openBlock(), _createBlock(_component_app_dropdown, { class: "user-menu" }, {
    "dropdown-button": _withCtx(() => [
      _createElementVNode("img", {
        src: (_ctx.user && _ctx.user.picture) ? _ctx.user.picture : require('@/assets/img/default-profile.png'),
        class: "user-image img-circle elevation-2",
        alt: "User Image"
      }, null, 8, _hoisted_1)
    ]),
    "dropdown-menu": _withCtx(() => [
      _createElementVNode("li", _hoisted_2, [
        _createElementVNode("img", {
          src: (_ctx.user && _ctx.user.picture) ? _ctx.user.picture : require('@/assets/img/default-profile.png'),
          class: "img-circle elevation-2",
          alt: "User Image"
        }, null, 8, _hoisted_3),
        _createElementVNode("p", null, [
          _createElementVNode("span", null, _toDisplayString(_ctx.user && _ctx.user.email), 1)
        ])
      ]),
      _createElementVNode("li", _hoisted_4, [
        _createVNode(_component_app_button, {
          onClick: _ctx.logout,
          class: "btn btn-default btn-flat float-right",
          block: false,
          loading: _ctx.isLogoutLoading
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ])
    ]),
    _: 1
  }))
}